import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { DECISION_TYPE_CODE } from '@src/constants';
import { UserService } from '@src/core/services';
import { EventViewUI } from '@src/models';

import { BADGES } from './constants';

@Component({
  selector: 'new-list-item-event',
  templateUrl: './list-item-event.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-event.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemEventComponent {
  private readonly userService = inject(UserService);

  @Input() set item(data: EventViewUI | undefined) {
    this.data = data;
  }

  @Input() selectedId?: string;
  @Input() loading?: boolean;

  data?: EventViewUI;
  authUserId = this.userService.authUser?.id;

  isInvitation() {
    return (
      (this.data?.decisionTypeCode === DECISION_TYPE_CODE.Sended ||
        this.data?.decisionTypeCode === DECISION_TYPE_CODE.Readed) &&
      this.data?.status !== 5 &&
      (this.data?.dateEnd ? new Date(this.data?.dateEnd) >= new Date() : true)
    );
  }

  get badgeData() {
    if (this.data?.status === 5) {
      return BADGES.cancelled;
    } else if (this.data?.decisionTypeCode === DECISION_TYPE_CODE.Accepted) {
      return BADGES.accepted;
    } else if (this.data?.decisionTypeCode === DECISION_TYPE_CODE.Rejected) {
      return BADGES.rejected;
    } else if (this.data?.status === 6) {
      return BADGES.registrationStopped;
    }

    return;
  }

  getColor() {
    if (this.isInvitation()) {
      return 'var(--unions-color-green)';
    }

    if (this.data?.createdBy === this.authUserId) {
      return 'var(--unions-color-blue-light)';
    }

    return '';
  }
}
